import type { ICustomControlDiagnosticReportReadProps } from '../../interfaces/customControlDiagnosticReportReadProps';
import { FormParagraph, UserTextParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { DisplayIcd10 } from '../../utils/v1/Icd10/DisplayIcd10';

export function TpcV1DiagnosticReportSummary(props: ICustomControlDiagnosticReportReadProps) {
    return (
        <>
            {props.diagnosticReport.customControlData.diagnose_COPD_value && (
                <HorizontalFormGroupRead>
                    <FormLabel>Diagnose COPD:</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.diagnosticReport.customControlData.diagnose_COPD_value}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
            {props.diagnosticReport.customControlData.diagnose_astma_value && (
                <HorizontalFormGroupRead>
                    <FormLabel>Diagnose astma:</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.diagnosticReport.customControlData.diagnose_astma_value}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
            {props.diagnosticReport.customControlData.bezoek_aan_specialist_nodig && (
                <HorizontalFormGroupRead>
                    <FormLabel>Bezoek aan specialist nodig?</FormLabel>
                    <InputContainer>
                        <FormParagraph>
                            {props.diagnosticReport.customControlData.bezoek_aan_specialist_nodig}
                        </FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
            {props.diagnosticReport.customControlData.bezoek_aan_specialist_nodig === 'Zie advies' &&
                props.diagnosticReport.customControlData.advies && (
                    <HorizontalFormGroupRead>
                        <FormLabel>Advies</FormLabel>
                        <InputContainer>
                            <UserTextParagraph>{props.diagnosticReport.customControlData.advies}</UserTextParagraph>
                        </InputContainer>
                    </HorizontalFormGroupRead>
                )}
            {(props.diagnosticReport.customControlData.diagnose_COPD_value === 'Anders' ||
                props.diagnosticReport.customControlData.diagnose_astma_value === 'Anders') &&
                props.diagnosticReport.diagnosis?.diagnosisConsiderationIcd10 && (
                    <HorizontalFormGroupRead>
                        <FormLabel>Waarschijnlijkheidsdiagnose</FormLabel>
                        <InputContainer>
                            <FormParagraph>
                                <DisplayIcd10
                                    icd10Code={props.diagnosticReport.diagnosis.diagnosisConsiderationIcd10}
                                    thesaurusTermDate={props.diagnosticReport.dateSent}
                                    thesaurusTermId={props.diagnosticReport.diagnosis.considerationThesaurusTermId}
                                />
                            </FormParagraph>
                        </InputContainer>
                    </HorizontalFormGroupRead>
                )}
        </>
    );
}
